import { Schema } from 'rsuite';

const { Model, Types } = Schema;

export type InsuranceFormType = {
  name: string;
  subtitle: string;
  displayName: string;
  isDisabled: boolean;
  insuranceCounty: string[];
  payerID?: string;
  code?: string;
};

export const InsuranceFormSchema = Model({
  name: Types.StringType().isRequired('Name is required'),
  displayName: Types.StringType().isRequired('Display Name is required'),
  code: Types.StringType().isRequired('Code is required'),
  isDisabled: Types.BooleanType(),
  insuranceCounty: Types.ArrayType(),
});
